export const WorkflowConstants = {
  attributes: {
    querySourceTab: "query-source-tab",
    toolSpecDropDown: "toolSpecDropDown"
  }
};
